import { PolicyAddedScreen } from 'components/screens';
import Uploader, { UploaderPreviews } from 'components/uploader';
import { useUploader } from 'hooks/useUploader';
import styles from '../styles/renewalUpload.scss';
import { Back, Button } from 'components/quashed';
import { HOME_ROUTE } from 'constants/routes';
import {
  TRACKING_EVENTS,
  getComparePolicyRoute,
  trackEventWithData,
} from 'helpers';

const RenewalUpload = ({
  next,
  policy,
  submitting,
  submitted,
  prevButtonText,
  showMarketScanBtn,
  onPrevBtnClick,
  resetPolicyForm,
  createPolicyRenewalWithAttachments,
}) => {
  const handleSubmit = (attachments) => {
    trackEventWithData(TRACKING_EVENTS.PolicyRenewalUpload, policy);
    createPolicyRenewalWithAttachments(policy, attachments);
  };

  const {
    attachments: filesToUpload,
    uploaderRef,
    rejected,
    openUploader,
    removeAttachment,
    onSubmit,
    onDrop,
    popupProps,
    onPopupAction,
  } = useUploader(handleSubmit);

  if (submitted) {
    return (
      <PolicyAddedScreen
        next={next}
        showButton={false}
        text={
          <b className={styles.uploadingText}>
            It’ll take just a few moments. Our system is picking up the
            information!
            <br />
            You’ll see your new policy renewal information soon.
          </b>
        }
        showSpinner={true}
        resetPolicyForm={resetPolicyForm}
      />
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.uploadContainer}>
        <Uploader
          ref={uploaderRef}
          onDrop={onDrop}
          className={styles.uploader}
          isUploading={submitting}
          onPopupAction={onPopupAction}
          popupProps={popupProps}
        >
          {filesToUpload.length && (
            <UploaderPreviews
              attachments={filesToUpload}
              removeAttachment={removeAttachment}
            />
          )}
        </Uploader>
      </div>

      <div className={styles.btnContainer}>
        <Back
          className={styles.back}
          link={!onPrevBtnClick && HOME_ROUTE}
          onClick={onPrevBtnClick}
          text={prevButtonText}
        />
        {filesToUpload.length > 0 ? (
          <Button
            className={styles.blueBtn}
            text="Upload"
            onClick={onSubmit}
            disabled={submitting}
          />
        ) : (
          showMarketScanBtn && (
            <Button
              className={styles.marketScanBtn}
              link={getComparePolicyRoute(policy.id)}
              text="Find better deals"
            />
          )
        )}
      </div>
    </div>
  );
};

export default RenewalUpload;
